// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__KgPLe","buttons":"PendingPaymentAlert_buttons__3IqMN"};